export default __webpack_public_path__ + "static/media/850.f6644c78.png";